import React from "react";
import formatNumber from "../../../helpers/NumberFormat";
import "./transfer.scss";

const FormStep3 = ({ formStep1SelectedOption, data, main }) => {

    const getAccreditedDate = (selectedDateStr) => {
        const now = new Date();
        const selectedDate = new Date(selectedDateStr);
        const isToday = now.toDateString() === selectedDate.toDateString();

        let workingDaysToAdd = 2;

        if (isToday && now.getHours() >= 12) {
            workingDaysToAdd = 3;
        }

        let resultDate = new Date(selectedDate);

        while (workingDaysToAdd > 0) {
            resultDate.setDate(resultDate.getDate() + 1);

            const day = resultDate.getDay();
            if (day !== 0 && day !== 6) {
                workingDaysToAdd--;
            }
        }

        return formatDate(resultDate);
    };

    const formatDate = (date) => {
        const day = ("0" + date.getDate()).slice(-2);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    return (
        <div className="container py-4">
            <h5 className="text-uppercase fw-bold mb-3">Single Transfer</h5>

            <section className="mb-4">
                <h6 className="text-muted fw-bold">Sender</h6>
                <div className="bg-light p-3">
                    <div className="row mb-2">
                        <div className="col-md-4">Debit account:</div>
                        <div className="col-md-8 text-end fw-bold">{main?.user?.detail?.account_number}</div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-md-4">Account holder:</div>
                        <div className="col-md-8 text-end fw-bold">{main?.user?.first_name} {main?.user?.last_name}</div>
                    </div>
                    {/* <div className="row">
            <div className="col-md-4">Branch:</div>
            <div className="col-md-8 text-end fw-bold">DARFO BOARIO TERME - 4092</div>
          </div> */}
                </div>
            </section>

            <section className="mb-4">
                <h6 className="text-muted fw-bold">Beneficiary</h6>
                <div className="bg-light p-3">
                    <div className="row mb-2">
                        <div className="col-md-4">IBAN:</div>
                        <div className="col-md-8 text-end fw-bold">{data.iban}</div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-md-4">BIC/SWIFT:</div>
                        <div className="col-md-8 text-end fw-bold">{data.swift_code}</div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-md-4">Account holder:</div>
                        <div className="col-md-8 text-end fw-bold">{data.beneficary_name}</div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-md-4">Beneficiary's bank:</div>
                        <div className="col-md-8 text-end fw-bold">{data.bank_name}</div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">Beneficiary's country:</div>
                        <div className="col-md-8 text-end fw-bold">{data.beneficary_country}</div>
                    </div>
                </div>
            </section>

            <section className="mb-4">
                <h6 className="text-muted fw-bold">Disposition Data</h6>
                <div className="bg-light p-3">
                    <div className="row mb-2">
                        <div className="col-md-4">Amount:</div>
                        <div className="col-md-8 text-end fw-bold">{formatNumber(data.amount)} €</div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-md-4">Fees:</div>
                        <div className="col-md-8 text-end fw-bold">{formatNumber(0)} €</div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-md-4">Total amount:</div>
                        <div className="col-md-8 text-end fw-bold">{formatNumber(data.amount)} €</div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">Reason:</div>
                        <div className="col-md-8 text-end fw-bold">{data.description}</div>
                    </div>
                </div>
            </section>

            <section className="mb-4">
                <h6 className="text-muted fw-bold">Execution Data</h6>
                <div className="bg-light p-3">
                    <div className="row mb-2">
                        <div className="col-md-4">Transfer type:</div>
                        <div className="col-md-8 text-end fw-bold">{formStep1SelectedOption}</div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-md-4">Execution date:</div>
                        <div className="col-md-8 text-end fw-bold">{data?.execution_date}</div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">Accredited date:</div>
                        <div className="col-md-8 text-end fw-bold">{getAccreditedDate(data.execution_date)}</div>
                    </div>
                </div>
            </section>

            <div className="bg-light p-3 text-muted">
                In case of failed operation, a notification will be sent to the following phone number:
                <strong className="ms-2">
                    {main?.user?.detail?.otp_phone_nr?.startsWith('+')
                        ? main.user.detail.otp_phone_nr
                        : '+' + main.user.detail.otp_phone_nr}
                </strong>
            </div>

            <div className="bg-info-subtle border-start border-primary border-4 rounded p-3 mt-3 text-muted">
                ⚠️ <strong>WARNING:</strong> Confirm the operation only if you are sure of the data and the identity of the beneficiary.
                Our operators will never contact you to request your IBAN or payment details.
            </div>
        </div>
    );
};

export default FormStep3;